import { MetosMeasurementType, MetosStationType } from "services/iot/enums";

export interface ForecastCityDto {
    id: number;
    name: string;
    localizedName: string;
}
export interface County {
    id: number;
    name: string;
}

export interface City {
    id: number;
    name: string;
    zupanija: County;
}

export interface Equipment {
    id: number;
    semisId: number;
    name: string;
    deviceId: string;
    inventoryNumber: string;
    county: string;
    category: string;
    type: string;
    arKod: string;
    parcelNumber: string;
    culture: string;
    location: string;
    remark: string;
    active: boolean;
    activeRemark: string;
    createdAt: Date;
    updatedAt?: Date;
}

export interface PinovaData {
    id: number;
    measurementAt: Date;
    value: string;
    comment?: string;
}

export interface PinovaSensor {
    id: number;
    name: string;
    unit: string;
    pinovaData: PinovaData[];
}

export interface PinovaStation {
    id: number;
    name: string;
    editName?: string;
    imei: string;
    location: string;
    owner: string;
    setupDate?: Date;
    crop: string;
    address: string;
    phoneNumber: string;
    serialNo: string;
    otherInformation: string;
    lat: string;
    lon: string;
    zupanija: County;
    grad: City;
    pinovaSensors: PinovaSensor[];
    equipment?: Equipment;
}

export interface MeasurementData {
    id: number;
    date: Date;
    sensorName: string;
    type: MetosMeasurementType;
    value: string;
    unit: string;
    imageUrl: string;
    imageThumbUrl: string;
    phenophaseId?: number;
    comment?: string;
}

export interface MetosStation {
    id: number;
    stationId: string;
    name: string;
    editName?: string;
    key: string;
    lat: string;
    lon: string;
    zupanija: County;
    grad: City;
    crop: string;
    location: string;
    address: string;
    createdDate: Date;
    active: boolean;
    type: MetosStationType;
    measurementData: MeasurementData[];
    equipment?: Equipment;
}

export interface Phenophase {
    id: number;
    name?: string;
    description?: string;
    active?: boolean;
    /** mapped from DB column “predmet_opazanja_id_id” */
    predmetOpazanjaIdId?: number;
    /** mapped from DB column “vrsta_id_id” */
    vrstaIdId?: number;
}

export interface DoubleValueRange {
    min?: number;
    max?: number;
}

export enum AlarmTypeEnum {
    None = 0,
    Regular = 1,
    ForSpecificLoockbackDays = 2,
    Phenophase = 3,
}

export interface StationAlarm {
    id?: number;
    userId?: string;
    createdAt?: Date;
    metosStationId?: number;
    metosStation?: MetosStation;
    pinovaStationId?: number;
    pinovaStation?: PinovaStation;
    measurementType?: string;
    measurementUnit?: string;
    valueRange?: DoubleValueRange;
    amount?: number;
    lookbackDays?: number;
    type?: AlarmTypeEnum;
}

export interface PhytoViewAlarm {
    id?: number;
    userId?: string;
    createdAt?: Date;
    countyId?: number;
    jlsId?: number;
    fazaRazvojaId?: number;
    stetniOrganizamId?: number;
    intenzitet?: string;
    note?: string;
}

export interface UserAlarmsResponse {
    metosStaion?: MetosStation;
    pinovaStation?: PinovaStation;
    stationAlarms: StationAlarm[];
    phytoViewAlarms: PhytoViewAlarm[];
}
